import { FilterOption } from '../types/filters'

export const WRAPPER_TYPE_OPTIONS: FilterOption[] = [
  { value: 'connecticut', label: 'Connecticut' },
  { value: 'maduro', label: 'Maduro' },
  { value: 'natural', label: 'Natural' },
  { value: 'colorado', label: 'Colorado' },
  { value: 'claro', label: 'Claro' },
  { value: 'oscuro', label: 'Oscuro' },
  { value: 'candela', label: 'Candela' },
]

export const STRENGTH_LEVEL_OPTIONS: FilterOption[] = [
  { value: 'mild', label: 'Mild' },
  { value: 'mild-medium', label: 'Mild-Medium' },
  { value: 'medium', label: 'Medium' },
  { value: 'medium-full', label: 'Medium-Full' },
  { value: 'full', label: 'Full' },
]

export const STATUS_OPTIONS: FilterOption[] = [
  { value: 'available', label: 'Available' },
  { value: 'smoked', label: 'Smoked' },
  { value: 'traded', label: 'Traded' },
  { value: 'gifted', label: 'Gifted' },
  { value: 'damaged', label: 'Damaged' },
]

export const ORIGIN_OPTIONS: FilterOption[] = [
  { value: 'cuba', label: 'Cuba' },
  { value: 'dominican republic', label: 'Dominican Republic' },
  { value: 'nicaragua', label: 'Nicaragua' },
  { value: 'honduras', label: 'Honduras' },
  { value: 'mexico', label: 'Mexico' },
  { value: 'ecuador', label: 'Ecuador' },
  { value: 'usa', label: 'USA' },
]

export const DEFAULT_PAGE_SIZE = 12
export const PAGE_SIZE_OPTIONS = [12, 24, 48]
